// Patch 33 · supporters: open the "Become a Supporter" pop-up from anywhere (the pop-up itself loads on demand)
// and read the public list / Buy Me a Coffee link once per visit.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function openSupporter() {
  window.dispatchEvent(new Event("tier:supporter"));
}

let cache = null;
let inflight = null;
export function useSupporters() {
  const [d, setD] = useState(cache);
  useEffect(() => {
    if (cache) return undefined;
    let alive = true;
    inflight = inflight || api.get("/supporters").then(({ data }) => data).catch(() => ({ link: "", people: [] }));
    inflight.then((data) => { cache = data; if (alive) setD(data); });
    return () => { alive = false; };
  }, []);
  return d;
}
